import { observer } from 'mobx-react-lite'
import { SpinnerLoader } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { useDiscoverContext } from 'pages/discover/context/context'
import { BoxListCard } from 'pages/discover/ui/BoxListCard/BoxListCardCard'
import styles from './styles.module.scss'

export const BoxesList = observer(() => {
  const store = useDiscoverContext()
  const { boxesList, listLoading } = store

  if (listLoading) return <SpinnerLoader ariaLabel={'BoxesList'} />

  return (
    <div className={styles.list} aria-label={getAriaLabel('IntegrationCards')}>
      {boxesList.map((box) => (
        <BoxListCard key={box.id} box={box} store={store} />
      ))}
    </div>
  )
})
